export const ApplicantOptions = [
  { label: "Guarantor Removal", value: "Guarantor Removal" },
  { label: "Co-applicant Removal", value: "Co-applicant Removal" },
  { label: "KLI Removal", value: "KLI Removal" },
];
